export default "__VITE_ASSET__CFC0IPnN__"